<template>
    <div class="report-data-area-box report-radar-data-area-box">
        <div class="report-data-radar-area" v-bind:id="canvasId"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportDataArea',
	props: ['canvasId', 'indicatorArr', 'valueArr'],
    mounted() {
		var me = this;
        setTimeout(() => {
			me.initEcharts();
        }, 20);
    },
    methods: {
        initEcharts() {
            var me = this;
            var canvasDom = document.getElementById(this.canvasId);
            if(canvasDom == null) { return; }
            // 基于准备好的dom，初始化echarts实例
            var myChart = echarts.init(canvasDom);
            console.log('init-------', echarts, me.xDataArr, me.yDataArr)
            // 绘制图表
            myChart.setOption({
				title: {
					text: '基础雷达图'
				},
				textStyle: {
					fontSize: 12,
				},
				tooltip: {},
				radar: {
					name: {
						textStyle: {
							color: '#B26106',
							padding: [-7, -7]
						}
					},
					indicator: me.indicatorArr,
					axisLine: {
						lineStyle: {
							color: '#EAC96B'
						}
					},
					splitLine: {
						lineStyle: {
							color: '#EAC96B'
						}
					},
					splitArea: {
						areaStyle: {
							color: ['#FEF2DF', '#FEEBD0']
						}
					}
				},
				series: [{
					type: 'radar',
					lineStyle: {
						color: '#E02020'
					},
					areaStyle: {opacity: 0.3},
					symbol: 'none',
					data: [
						{ value: me.valueArr }
					]
				}]
            });
            // console.log('initEcharts------', this.canvasId, canvasDom, echarts)
        }
    }
}
</script>